import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import {
  ASYNC_CREATE_MARKETING_PLAN,
  ASYNC_EDIT_MARKETING_PLAN,
  ASYNC_CHANGE_STATUS_MARKETING_PLAN,
} from 'store';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import { Form, Row, Col, Card, Alert } from 'react-bootstrap';
import Select from 'react-select';
import { DashboardOutlined } from '@material-ui/icons';

import BR from 'date-fns/locale/pt-BR';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import Flow from 'components/Flow';
import { formatDate, parseDate } from 'helpers/date';
import ActionStatus from 'enums/ActionStatus';

import MarketingPlanFormActions from 'components/MarketingPlan/Form/Actions';
import MarketingPlanFormFunds from 'components/MarketingPlan/Form/Funds';
import ExportTable from './ExportTable';
import PlanMarginResume from './Resume';
import History from 'components/History';

import Can from 'components/Can';

registerLocale('pt_BR', BR);

const MarketingPlanForm = ({
  landingPageApproval,
  createOrEditMarketingPlan,
  changeStatusMarketingPlan,
  match: {
    params: { id },
  },
}) => {
  const [status, setStatus] = useState('');
  const [company, setCompany] = useState('');
  const [rule, setRule] = useState('');
  const [planName, setPlanName] = useState('');
  const [projectName, setProjectName] = useState('');
  const [description, setDescription] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [approvalDate, setApprovalDate] = useState('');
  const [currentStatus, setCurrentStatus] = useState('');
  const [companies, setCompanies] = useState([]);
  const [rules, setRules] = useState([]);
  const [funds, setFunds] = useState(false);
  const [actions, setActions] = useState({ data: [] });
  const [toSteps, setToSteps] = useState([]);
  const [component, setComponent] = useState(false);
  const [cantCancel, setCantCancel] = useState(true);
  const [cantSendApproval, setCantSendApproval] = useState(true);
  const [hash, setHash] = useState();
  const [disableButton, setDisableButton] = useState(false);

  const [messageAlert, setMessageAlert] = useState('');
  const [histories, setHistories] = useState([]);
  const [historyComment, setHistoryComment] = useState('');
  const [currency, setCurrency] = useState('1');

  var VendorsArr = [];

  const handleApprove = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('plan_id', id);
    formData.append('current_status', currentStatus);
    formData.append('to_status', 8);
    landingPageApproval(formData);
    setDisableButton(true);
  };

  const handleDisapproved = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('plan_id', id);
    formData.append('current_status', currentStatus);
    formData.append('to_status', 7);
    landingPageApproval(formData);
    setDisableButton(true);
  };

  const disabled = (data) => {
    let disable = false;
    if (data.status_id !== 20) {
      disable = true;
    }
    return disable;
  };

  const handleChangePeriod = useCallback(
    (value) => {
      setRule(value);
      api.get(`funds/list-by-company-rule/${value}`).then(({ data }) => {
        const funds = [...data];
        if (!!id && actions.length !== 0) {
          api
            .get(`action-values/list-by-company-rule/${value}`, {
              params: { marketing_plan_id: id },
            })
            .then(({ data }) => {
              funds.forEach((fund, k) => {
                let used_in_plan = 0;
                data.forEach((actionValue) => {
                  if (fund.type.id === actionValue.fund_type_id)
                    used_in_plan +=
                      actionValue.actual_value +
                      (actionValue.funds_expire_value ?? 0);
                });
                funds[k] = {
                  ...funds[k],
                  ...{ used_in_plan: used_in_plan },
                };
              });
            });
        }
        setFunds(funds);
      });
    },
    [id, actions]
  );

  useEffect(() => {
    api.get('companies/rules').then(({ data }) => {
      setCompanies(data);
    });

    if (id) {
      api.get(`marketing-plans/${id}`).then(({ data }) => {
        handleChangeCompany(data.company_id);
        setCompany(data.company_id);
        setRule(data.company_rule_id);
        handleChangePeriod(data.company_rule_id);
        setPlanName(data.name);
        setProjectName(data.project_name);
        setDescription(data.description);
        setDeliveryDate(new Date(parseDate(data.delivery_date)));
        setApprovalDate(new Date(parseDate(data.approval_date)));
        setCurrentStatus(data.status_id);
        setCantCancel(data.cant_cancel);
        setCantSendApproval(data.cant_send_approval);
        setHash(data.landing_hash);
        setDisableButton(disabled(data));
        setHistories(data.histories);
        setCurrency(data.currency_id?data.currency_id.toString():'1');
      });
    }
  }, [id, handleChangePeriod]);

  const getVendors = () => {
    companies.map((company) => {
      return VendorsArr.push({
        label: company.alias,
        value: company.id,
      });
    });

    VendorsArr.sort((a, b) => {
      return +(a.label > b.label) || +(a.label === b.label) - 1;
    });

    VendorsArr.map((label) => {
      return companies[label.index];
    });
  };

  const findVendors = (value) => {
    let flag;
    VendorsArr.map((v, k) => {
      if (value === v.value) {
        flag = k;
      }
    });
    return flag;
  };

  const { t } = useTranslation();

  const handleChangeCompany = (value) => {
    setCompany(value);
    setRule('');
    setFunds(false);
    return api.get(`companies/${value}/available-rules`).then(({ data }) => {
      setRules(data.rules);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    createOrEditMarketingPlan({
      id,
      status_id: status,
      company_id: company,
      company_rule_id: rule,
      name: planName,
      project_name: projectName,
      description,
      delivery_date: formatDate(deliveryDate),
      approval_date: formatDate(approvalDate),
      message_alert: messageAlert,
      history_comment: historyComment,
    });
  };

  const handleChangeStatus = (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append('plan_id', id);
    formData.append('current_status', currentStatus);
    formData.append('to_status', status);
    formData.append('message_alert', messageAlert);
    formData.append('history_comment', historyComment);
    changeStatusMarketingPlan(formData);
  };

  useEffect(() => {
    if ((currentStatus && id) || (!currentStatus && !id)) {
      api
        .get(
          currentStatus
            ? `flows/${2}/status/${currentStatus}`
            : `flows/${2}/status`
        )
        .then(({ data }) => {
          if (data.steps[0]) {
            if (!!data.steps[0].to_steps) setToSteps(data.steps[0].to_steps);
            if (!!data.steps[0].components)
              setComponent(data.steps[0].components[0]);
          }
        });
    }
  }, [currentStatus, id]);

  const readOnlySelect = !!id &&
    actions.length !== 0 && {
      style: { background: '#eee', pointerEvents: 'none', touchAction: 'none' },
      tabIndex: -1,
    };

  var actualCompany = false;

  companies.forEach((cp) => {
    if (cp.id === parseInt(company)) actualCompany = cp;
  });

  getVendors();

  return (
    <Form
      onSubmit={
        currentStatus !== ActionStatus.Disapproved &&
        currentStatus !== ActionStatus.Draft &&
        id
          ? handleChangeStatus
          : handleSubmit
      }
    >
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
        <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">
              {t('title:marketing plan register')}
              {id && <>&nbsp;- Vendor: {actualCompany.alias}</>}
            </h4>
          </Col>
        </Row>
        <Row className="mt-4">
          {!!id ? (
            <Col>
              <PlanMarginResume planId={id} actions={actions.data} currency={currency}/>
            </Col>
          ) : (
            ''
          )}
        </Row>
        <hr />
        <Row className="mt-2">
          {!!id ? (
            <Col>
              <ExportTable
                planName={planName}
                id={id}
                company={actualCompany.alias}
                rule={rule}
                handleChangePeriod={handleChangePeriod}
                projectName={projectName}
                description={description}
                deliveryDate={approvalDate}
                funds={funds}
                actions={actions}
              />
            </Col>
          ) : (
            ''
          )}
        </Row>
        <Row className="mt-2 mb-3">
          <Col>
            <Row className="mt-3">
              {!!id && (
                <Col xs={2}>
                  <Form.Label>{t('label:id')}</Form.Label>
                  <Form.Control value={id} disabled />
                </Col>
              )}
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:company')}</Form.Label>
                  <Select
                    key={company}
                    name="vendor"
                    mode="input"
                    options={VendorsArr}
                    placeholder={t('label:select')}
                    required
                    isDisabled={!!id}
                    onChange={(e) => {
                      setCompany(e.value);
                      setRule('');
                      setFunds(false);
                      companies.forEach((company) => {
                        if (company.id === parseInt(e.value))
                          api
                            .get(`companies/${e.value}/available-rules`)
                            .then(({ data }) => setRules(data.rules));
                      });
                    }}
                    defaultValue={VendorsArr[findVendors(company)]}
                    noOptionsMessage={() => t('label:loading')}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:period')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={rule}
                    onChange={(e) => {
                      handleChangePeriod(e.target.value);

                      rules.forEach((rule) => {
                        if (rule.id === parseInt(e.target.value)) {
                          setDeliveryDate(new Date(parseDate(rule.plan_start)));
                          setApprovalDate(new Date(parseDate(rule.plan_end)));
                        }
                      });
                    }}
                    required
                    {...readOnlySelect}
                  >
                    <option disabled value="">
                      {t('label:select')}
                    </option>
                    {rules.filter((f) => id ? f : f.deleted_at == null).map((rule, k) => (
                      <option key={k} value={rule.id}>
                        {rule.period.type.name} {rule.period.position}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-3 mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:plan name')}</Form.Label>
                  <Form.Control
                    value={planName}
                    onChange={(e) => setPlanName(e.target.value)}
                    required
                    disabled={!component.editable}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:project name')}</Form.Label>
                  <Form.Control
                    value={projectName}
                    disabled={!component.editable}
                    onChange={(e) =>
                      e.target.value !== ''
                        ? setProjectName(e.target.value)
                        : setProjectName('')
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12} md={12}>
                <Form.Group>
                  <Form.Label>{t('label:brief description')}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="4"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    disabled={!component.editable}
                  />
                </Form.Group>
              </Col>
            </Row>
            {rule && (
              <>
                <Row className="mt-3 mb-3">
                  <Col>
                    <Form.Group>
                      <Form.Label className="mr-3">
                        {t('label:plan delivery date')}
                      </Form.Label>
                      <DatePicker
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        locale="pt_BR"
                        selected={approvalDate}
                        onChange={(date) => setApprovalDate(date)}
                        required
                        disabled={!component.editable}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
            {!funds ? (
              !!rule
            ) : (
              <Row className="mt-3 mb-3">
                <Col>
                  <MarketingPlanFormFunds funds={funds} mpid={id} />
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        {id && currentStatus? (
          <MarketingPlanFormActions
            setActions={setActions}
            actions={actions}
            planId={id}
            companyId={company}
            companyRuleId={rule}
            component={component}
            status={currentStatus}
            hash={hash}
          />
        ) : (
          <Alert variant="info" className="mt-2 mb-0">
            {t('phrase:you must save the plan to add actions.')}
          </Alert>
        )}
        <Form.Group className="mt-4">
          <Form.Label>{t('label:additional information')}</Form.Label>
          <Form.Control
            as="textarea"
            value={historyComment}
            onChange={(e) => setHistoryComment(e.target.value)}
            rows="4"
          />
        </Form.Group>
        {id && currentStatus ? (
          <Row className="mt-3 mb-3">
            <Col>
              <Can do={`${currentStatus}`} on="App">
                <Flow
                  setMessageAlert={setMessageAlert}
                  toSteps={toSteps}
                  setStatus={setStatus}
                  notShow={{
                    [ActionStatus.OnApproval]: cantSendApproval,
                    [ActionStatus.Cancelled]: cantCancel,
                    [ActionStatus.Approved]: cantSendApproval,
                    [ActionStatus.Disapproved]: cantCancel,
                    [ActionStatus.CustomerApproval]: cantSendApproval,
                  }}
                />
              </Can>
            </Col>
          </Row>
        ) : (
          <Row className="mt-3 mb-3">
            <Col>
              <Flow
                setMessageAlert={setMessageAlert}
                toSteps={toSteps}
                setStatus={setStatus}
                notShow={{
                  [ActionStatus.OnApproval]: !id || cantSendApproval,
                  [ActionStatus.Cancelled]: cantCancel,
                  [ActionStatus.Approved]: cantSendApproval,
                  [ActionStatus.Disapproved]: cantCancel,
                  [ActionStatus.CustomerApproval]: cantSendApproval,
                }}
              />
            </Col>
          </Row>
        )}
        <Row className="mt-3 mb-3">
          <Col>
            <History histories={histories} />
          </Col>
        </Row>
      </Card.Body>
    </Form>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  createOrEditMarketingPlan: (payload) => {
    if (!!payload.id) dispatch({ type: ASYNC_EDIT_MARKETING_PLAN, payload });
    else dispatch({ type: ASYNC_CREATE_MARKETING_PLAN, payload });
  },
  changeStatusMarketingPlan: (payload) => {
    dispatch({ type: ASYNC_CHANGE_STATUS_MARKETING_PLAN, payload });
  },
  landingPageApproval: (payload) => {
    dispatch({ type: 'ASYNC_LANDING_APPROVAL', payload });
  },
});

const reduxConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketingPlanForm);

export default MasterPage(reduxConnect);
